import { derived } from 'svelte/store'
import { page } from '$app/stores'

export const prefix = derived(page, ($page) =>
  prefixForLanguage(
    $page.data.language,
    $page.data.agent?.settings?.data.default_language
  )
)

export function prefixForLanguage(language, defaultLanguage) {
  defaultLanguage = defaultLanguage ?? import.meta.env.PUBLIC_DEFAULT_LANGUAGE
  return language == null || language === defaultLanguage ? '' : `/${language}`
}
